<script>
  import { fade } from "svelte/transition";
  
  export let experience;
</script>

<div 
  class="bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm rounded-2xl shadow-sm border border-gray-200/50 dark:border-gray-700/50 overflow-hidden"
  in:fade={{ duration: 300 }}
>
  <!-- Card header with company info -->
  <div class="p-6 md:p-8 flex flex-col md:flex-row md:items-center gap-6 border-b border-gray-100 dark:border-gray-700/50 relative">
    <!-- Duration Badge - Positioned absolute for visual emphasis -->
    <div class="absolute top-4 right-4 md:top-6 md:right-6">
      <div class="px-3 py-1.5 rounded-full text-sm font-bold bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-md transform transition-all duration-300 hover:scale-105 hover:shadow-lg">
        {experience.duration}
      </div>
    </div>
    
    <div class="w-16 h-16 md:w-20 md:h-20 rounded-2xl overflow-hidden bg-white dark:bg-gray-900 p-3 md:p-4 border border-gray-200 dark:border-gray-700 shadow-sm flex-shrink-0 mx-auto md:mx-0">
      <img 
        src={experience.logo} 
        alt={experience.name}
        class="w-full h-full object-contain"
      />
    </div>
    
    <div class="text-center md:text-left">
      <h2 class="text-xl md:text-2xl font-bold text-gray-900 dark:text-white bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-purple-600">{experience.name}</h2>
      <div class="mt-2 flex flex-col md:flex-row md:items-center gap-2 md:gap-4">
        <p class="text-base md:text-lg font-semibold text-gray-800 dark:text-gray-200">{experience.position}</p>
        <div class="hidden md:block w-1.5 h-1.5 rounded-full bg-gray-400 dark:bg-gray-600"></div>
        <span class="text-blue-600 dark:text-blue-400 font-medium">{experience.displayStart} - {experience.displayEnd}</span>
      </div>
    </div>
  </div>
  
  <!-- Card content -->
  <div class="p-6 md:p-8">
    <div class="space-y-4">
      <h3 class="text-lg font-semibold text-gray-800 dark:text-white">About this role</h3>
      <p class="text-gray-600 dark:text-gray-300 leading-relaxed">
        {experience.description}
      </p>
      
      <!-- Skills tags -->
      <div class="mt-6">
        <h4 class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">Skills & Technologies</h4>
        <div class="flex flex-wrap gap-2">
          {#each experience.skills as skill}
            <span class="px-3 py-1 rounded-full text-xs font-medium bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-gray-200/50 dark:border-gray-700/50 hover:bg-blue-50 dark:hover:bg-blue-900/20 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200">
              {skill}
            </span>
          {/each}
        </div>
      </div>
    </div>
  </div>
</div> 